import React from 'react';
import useQueryString from '../../../../hooks/use-query-string';
import HolidayDisplay from '../../../HolidayDisplay';

export default function Holiday() {
  const { sch: schoolId, sid: studentId } = useQueryString();

  return (
    <HolidayDisplay schoolId={schoolId} studentId={studentId} />
  );
}
